import * as echarts from 'echarts/core';
import { BarChart, LineChart, PieChart, HeatmapChart, FunnelChart, CustomChart } from 'echarts/charts';
import {
  TooltipComponent, GridComponent, TitleComponent, LegendComponent,
  VisualMapComponent, MarkLineComponent, GraphicComponent,
} from 'echarts/components';
import { CanvasRenderer, SVGRenderer } from 'echarts/renderers';

// Only what the app uses. A series/component missing here renders as a blank chart with no error in a
// production build, so chartCoverage.test.js scans the sources and fails on anything not listed.
export const REGISTERED_SERIES = ['bar', 'line', 'pie', 'heatmap', 'funnel', 'custom'];
export const REGISTERED_COMPONENTS = ['tooltip', 'grid', 'title', 'legend', 'visualMap', 'markLine', 'graphic'];

echarts.use([
  BarChart, LineChart, PieChart, HeatmapChart, FunnelChart, CustomChart,
  TooltipComponent, GridComponent, TitleComponent, LegendComponent,
  VisualMapComponent, MarkLineComponent, GraphicComponent,
  CanvasRenderer, SVGRenderer,
]);

export { echarts };
